import React, { FC } from "react";

import { Chip } from "@components/base";

interface ChipId {
  id: string;
}

const ChipId: FC<ChipId> = ({ id }) => {
  return (
    <Chip
      variant="filled"
      size="medium"
      label={`${id.substring(0, 4)}...${id.substring(id.length - 5)}`}
      color="blue1"
      onClick={() => {}}
    />
  );
};

export default ChipId;
